import { useAuthState } from "../../context/AuthContext";
import AdminDashboard from "./AdminDashboard";
import AgronomistDashboard from "./AgronomistDashboard";
import CropSupervisorDshboard from "./CropSupervisorDshboard";
import EquipmentTechnicianDashboard from "./EquipmentTechnicianDashboard";
import FarmManagerDashboard from "./FarmManagerDashboard";
import FarmOwnerDashboard from "./FarmOwnerDashboard";
import ProcurementDashboard from "./ProcurementDashboard";
import SalesDashboard from "./SalesDashboard";
import UserDashboard from "./UserDashboard";

const Dashboard = () => {
  const { userRole } = useAuthState();

  if (!userRole) return null;

  switch (userRole) {
    case "owner":
      return <FarmOwnerDashboard />;
    case "admin":
      return <AdminDashboard />;
    case "manager":
      return <FarmManagerDashboard />;
    case "technician":
      return <EquipmentTechnicianDashboard />;
    case "supervisor":
      return <CropSupervisorDshboard />;
    case "procurement":
      return <ProcurementDashboard />;
    case "destributor":
      return <SalesDashboard />;
    case "agronomist":
      return <AgronomistDashboard />;
    default:
      return <UserDashboard />;
  }
};

export default Dashboard;
